import { formatDate, formatTime } from '~/utils/dateHelpers'
import type { EventDate, EventDateChildren } from '~/composables/types/event'
import type { CartItem } from '~/composables/types/cart'

export const useEventDateHelpers = () => {
  const { locale } = useI18n()

  type GeneralDate = EventDate | CartItem | EventDateChildren

  const fnGetDateLabelHtml = (
    date: GeneralDate,
    currentDate = new Date()
  ): string => {
    if (typeof currentDate === 'string') {
      currentDate = new Date(currentDate)
    }

    const start = date?.start || date?.startTime
    const end = date?.end || date?.endTime

    if (!start || !end) {
      return ''
    }

    const eventDate = new Date(start)

    // Check if the event is more than 12 months after the current date
    const twelveMonthsLater = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth() + 12,
      1
    )

    const dateStr = formatDate(start, locale.value)
    const startTimeStr = formatTime(start)
    const endTimeStr = formatTime(end)

    const dateLabel =
      eventDate > twelveMonthsLater
        ? `${dateStr} ${eventDate.getFullYear()} ${startTimeStr} - ${endTimeStr}`
        : `${dateStr} ${startTimeStr} - ${endTimeStr}`
    return dateLabel
  }

  const fnGetChildrenHtmlArr = (item: GeneralDate) => {
    return (
      item.children?.data?.map((x: EventDateChildren) =>
        fnGetDateLabelHtml(x)
      ) || []
    )
  }

  return {
    fnGetDateLabelHtml,
    fnGetChildrenHtmlArr,
  }
}

export const getDateTime = (date: EventDate): string => {
  const start = date?.start
  const end = date?.end

  const startTimeStr = formatTime(start)
  const endTimeStr = formatTime(end)

  return `${startTimeStr} - ${endTimeStr}`
}
